import Header from "@/components/header";
import { NoResult } from "@/components/noResult";
import useIsSmall from "@/hooks/useIsSmall";
import { useGetAllNotification } from "@/services/notifications/hooks/useGetAllNotification";
import useUpdateReadMessage from "@/services/notifications/hooks/useUpdateReadMessage";
import {
  ActionIcon,
  Alert,
  Center,
  Container,
  Group,
  Loader,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import React, { useCallback, useRef } from "react";

function Notifications() {
  const queryClient = useQueryClient();
  const isSmall = useIsSmall();
  const { data, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useGetAllNotification({
      Count: 10,
      Skip: 0,
    });

  const observer = useRef<IntersectionObserver | null>(null);

  const lastCustomerElementRef = useCallback(
    (node: HTMLDivElement) => {
      if (isFetchingNextPage) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const { mutate } = useUpdateReadMessage();
  const read = (id: number) => {
    return () => {
      mutate(id, {
        onSuccess: () => {
          queryClient.invalidateQueries(["get-notification"]);
        },
      });
    };
  };

  return (
    <>
      <Header title="اعلان ها" showBack route="/dashboard/profile" />
      <Container w="100%" size="md">
        <Title order={4}> اعلان ها</Title>

        <Stack h={isSmall ? "100svh" : ""}>
          <Stack>
            <Stack px="md" gap="xs">
              {data?.pages.map((page, pageIndex) => (
                <React.Fragment key={pageIndex}>
                  {page?.result?.map((item, customerIndex) =>
                    page?.result?.length === customerIndex + 1 ? (
                      <div ref={lastCustomerElementRef}>
                        <Alert
                          key={item.id}
                          variant={item?.isOpened ? "default" : "light"}
                        >
                          <Group gap="xs" wrap="nowrap" align="start">
                            {!item?.isOpened && (
                              <ActionIcon
                                variant="light"
                                size="xs"
                                onClick={read(item.id || 0)}
                              >
                                <IconX size={15} />
                              </ActionIcon>
                            )}
                            <Text size="xs">{item.message}</Text>
                          </Group>
                        </Alert>
                      </div>
                    ) : (
                      <Alert
                        key={item.id}
                        variant={item?.isOpened ? "default" : "light"}
                      >
                        <Stack>
                          <Group gap="xs" wrap="nowrap" align="start">
                            {!item?.isOpened && (
                              <ActionIcon
                                variant="light"
                                size="xs"
                                onClick={read(item.id || 0)}
                              >
                                <IconX size={15} />
                              </ActionIcon>
                            )}

                            <Text size="xs">{item.message}</Text>
                          </Group>
                        </Stack>
                      </Alert>
                    )
                  )}
                </React.Fragment>
              ))}

              {data?.pages?.map((x) => x?.result?.length === 0 && <NoResult />)}
              {isFetchingNextPage && (
                <Center>
                  <Loader type="dots" />
                </Center>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}

export default Notifications;
